import { Component, OnInit, Inject, ErrorHandler } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../auth/auth/auth.service';
import { UserService } from '../user/user.service';
import { AirportService } from '../../airport/airport.service';


@Component({
  selector: 'app-review-move',
  templateUrl: './review-move.component.html',
  styleUrls: ['./review-move.component.scss']
})
export class ReviewMoveComponent implements OnInit {
  selectedEntityType: string;
  selectedEntity: string;
  formGroup: FormGroup;
  origType: string;
  origEntity: number;
  reviewId: number;

  constructor(public dialogRef: MatDialogRef<ReviewMoveComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _auth: AuthService,
              private _userService: UserService,
              private _errorHandler: ErrorHandler,
              private _snackBar: MatSnackBar,
              private _airportService: AirportService) {
    this.selectedEntityType = null;
    this.selectedEntity = null;
    this.origType = data.entityType;
    this.origEntity = data.entityId;
    this.reviewId = data.reviewId;
  }

  ngOnInit(): void {
    this.dialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
    this.formGroup = new FormGroup({
      entity_id: new FormControl(this.selectedEntity, [Validators.required, Validators.maxLength(4)]),
      type: new FormControl(this.selectedEntityType, [Validators.required])
    });
  }

  submitForm() {
    this.moveReview();
    // this.dialogRef.close();
  }

  async moveReview() {
    if (!this._auth.authenticated || !this._auth.endUser) {
      this._auth.redirectToLogin();
      return;
    }
    const snackBarOpts = { duration: 2000 };
    if (!this.selectedEntityType) {
      this._snackBar.open(`Entity type required.`, 'Dismiss', { duration: 5000 });
      return;
      // this.currentReview.rating = null;
    }
    if (!this.selectedEntity) {
      this._snackBar.open(`Entity Id required.`, 'Dismiss', { duration: 5000 });
      return;
      // this.currentReview.rating = null;
    }
    try {
      let newEntity: number;
      if (this.selectedEntityType === 'Airport') {
        const airportResponse = await this._airportService.getAirport(this.selectedEntity, true);
        if (airportResponse.airportId) {
          newEntity = airportResponse.airportId;
        } else {
          this._snackBar.open('Invalid airport identifier.', 'Dismiss', {duration: 6000});
          return;
        }
      } else {
        newEntity = Number(this.selectedEntity);
      }
      // moveReview(fromType: string, fromId: number, toType: string, toId: number, reviewId: number)
      const response = await this._userService.moveReview(this.origType, this.origEntity, this.selectedEntityType,
        newEntity, this.reviewId);
      if (response.errorMessage) {
        this._snackBar.open(response.errorMessage, 'Dismiss', { duration: 6000 });
        return;
      }
      this._snackBar.open(`Review moved.`, 'Dismiss', snackBarOpts);
      this.dialogRef.close({success: true});
    } catch (e) {
      this._snackBar.open('An error occurred moving the review. Please try again later.', 'Dismiss', snackBarOpts);
      this._errorHandler.handleError(e);

      // Set state to error, then reset after a few seconds to allow retry.
      this.dialogRef.close({success: true});
    }
  }

  /**
   * triggered by cancel button click event
   */
  cancel () {
    this.close({cancelBtnClicked: true});
  }

  /**
   * closes modal
   * @param data
   */
  close(data: any) {
    this.dialogRef.close(data);
  }
}
